module.exports = __webpack_public_path__ + "static/media/downloadButton.be65d1c0.svg";